package cz.bohouskovi.svatba.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import cz.bohouskovi.svatba.components.widgets.FlexBoxLayout
import cz.bohouskovi.svatba.components.widgets.ProtectedImage
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.*

private val WitnessItemStyle = Modifier
    .flex("18rem")
    .display(DisplayStyle.Flex)
    .flexDirection(FlexDirection.Column)
    .alignItems(AlignItems.Center)
    .textAlign(TextAlign.Center)
    .padding(1.cssRem)

@Composable
private fun WitnessItem(
    imageSrc: String,
    name: String,
    description: String,
    phone: String,
) {
    Column(
        modifier = WitnessItemStyle,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        ProtectedImage(src = imageSrc, alt = name, attrsBuilder = {
            attr(
                "style",
                "width:9rem;height:9rem;aspect-ratio:1/1;border-radius:50%;margin-bottom:0rem;object-fit:cover;"
            )
            attr("decoding", "async")
            attr("loading", "lazy")
        })
        H3 { Text(name) }
        P { Text(description) }
        A(href = "tel:$phone") {
            Text(phone)
        }
    }
}

@Composable
fun WitnessSection() {
    Column(
        modifier = Modifier.fillMaxWidth().id("svedci"),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        H2 { Text("Svědci") }

        FlexBoxLayout {
            WitnessItem(
                imageSrc = "tomik.webp",
                name = "Tomáš Pavlín - svědek ženicha",
                description = "S Tomíkem (prosím, oslovujte ho tak) se známe od střední. Společně jsme velcí odborníci na přetváření Silvestrovských chat v sauny a pojízdných aut v nepojízdná. Taky jsme proluštili nespočet letních nocí, takže pokud byste potřebovali poradit s luštěním svatebního kvízu, obraťte se na něj!",
                phone = "+420 737 735 228"
            )
            WitnessItem(
                imageSrc = "zuzka.webp",
                name = "Zuzka Tipková - svědkyně nevěsty",
                description = "Se Zuzkou se známe asi 10 let. Poznaly jsme se na vysoké škole. Za tu dobu jsme spolu zvládly překonat útrapy vysokoškolského studia, cestovat a nedávno jsme dokonce překonávaly strach z řízení s pomocí kondičních jízd. Zuzky si vážím, protože je to člověk, který vás rád vyslechne a podpoří a zároveň se s ní hodně nasmějete. Taky jako jedna z mála vydrží poslouchat moje dlouhá vyprávění. \uD83D\uDE00",
                phone = "+420 739 906 677"
            )
        }
    }
}
